import React from 'react';
import { CheckIcon, AlertTriangleIcon } from 'lucide-react';
import { forWho, notForWho } from '../data/content';
export function Audience() {
  return <section aria-labelledby="para-quien-titulo" className="w-full bg-sand-50 py-16 sm:py-24" data-id="element-14" data-mp="3p2fd4esjb775">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-15" data-mp="6smw15ds2k09">
        <h2 id="para-quien-titulo" className="font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-16" data-mp="1ulc6i8j2gnq">
          ¿Es esto para ti?
        </h2>

        <div className="mt-10 grid gap-10 md:grid-cols-2 md:gap-14" data-id="element-17" data-mp="btaxym3jol99">
          <div data-id="element-18" data-mp="plh0h5drytq8">
            <h3 className="flex items-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-ink" data-id="element-19" data-mp="pjxk7es4ciog">
              <CheckIcon aria-hidden="true" className="h-5 w-5 text-ember-600" strokeWidth={3} data-id="element-20" data-mp="lk5hvjtbj8rj" />
              Sí, si eres...
            </h3>
            <ul className="mt-5 space-y-4 border-t border-sand-200 pt-5" data-id="element-21" data-mp="ukk72u9el80b">
              {forWho.map(item => <li key={item} className="text-base leading-relaxed text-ink/75" data-id="element-22" data-mp="16dhxvb7p16lm">
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-23" data-mp="1gb5s801e0c39">
            <h3 className="flex items-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-ink" data-id="element-24" data-mp="1gamktd9d563h">
              <AlertTriangleIcon aria-hidden="true" className="h-5 w-5 text-navy-700" data-id="element-25" data-mp="1kdsm06hmc733" />
              No, si estás en...
            </h3>
            <ul className="mt-5 space-y-4 border-t border-sand-200 pt-5" data-id="element-26" data-mp="1p9q3ig4mbjhg">
              {notForWho.map(item => <li key={item} className="text-base leading-relaxed text-ink/60" data-id="element-27" data-mp="1u8knhlebne35">
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}